import{create as t}from"zustand";const n=t((()=>({identityToken:null})));function e(){let{identityToken:t}=n();return{identityToken:t}}export{n as useIdTokenStore,e as useIdentityToken};
